const ApplicationChannelStatuses = Object.freeze({
  active: 'active',
  error: 'error',
  inactive: 'inactive'
})

export { ApplicationChannelStatuses }



// WEBPACK FOOTER //
// ./src/modules/account/enum/ApplicationChannelStatusEnum.js